export default __webpack_public_path__ + "static/media/detail_big_12_3.170ede7b.jpg";